import React from 'react';
import { useLogin } from '../hooks/useLogin';

const LoginInput = () => {
	const { emailPlaceholder, passwordPlaceholder } = useLogin();

	return (
		<>
			<div className="vtex-login-2-x-inputContainer inputContainer vtex-login-2-x-inputContainerEmail inputContainerEmail">
				<label className="vtex-input w-100">
					<div className="vtex-input-prefix__group flex flex-row items-stretch overflow-hidden br2 bw1 b--solid b--muted-4 hover-b--muted-3 h-regular ">
						<input
							className="vtex-styleguide-9-x-input ma0 border-box vtex-styleguide-9-x-hideDecorators vtex-styleguide-9-x-noAppearance br2   w-100 bn outline-0 bg-base c-on-base b--muted-4 hover-b--muted-3 t-body ph5 "
							placeholder={emailPlaceholder}
							type="text"
							value=""
						></input>
					</div>
				</label>
			</div>
			<div className="vtex-login-2-x-inputContainer inputContainer vtex-login-2-x-inputContainerPassword inputContainerPassword pv3 flex flex-column">
				<div className="relative">
					<label className="vtex-input w-100">
						<div className="vtex-input-prefix__group flex flex-row items-stretch overflow-hidden br2 bw1 b--solid b--muted-4 hover-b--muted-3 h-regular ">
							<input
								className="vtex-styleguide-9-x-input ma0 border-box vtex-styleguide-9-x-hideDecorators vtex-styleguide-9-x-noAppearance br2  br-0 br--left  w-100 bn outline-0 bg-base c-on-base b--muted-4 hover-b--muted-3 t-body pl5 "
								placeholder={passwordPlaceholder}
								type="password"
								value=""
							></input>
							<span className="c-muted-2 fw5 flex items-center t-body bg-base  vtex-input__suffix br2 bl-0 br--right pr5 pl3 ">
								<span className="vtex-login-2-x-eyeIcon--invisible eyeIcon eyeIcon--invisible pointer">
									<svg
										fill="none"
										width="16"
										height="16"
										viewBox="0 0 16 16"
										className=" vtex-login-2-x-eyeSightIcon eyeSightIcon"
										xmlns="http://www.w3.org/2000/svg"
									>
										<use href="#mpa-eyesight--filled--on"></use>
									</svg>
								</span>
							</span>
						</div>
					</label>
				</div>
			</div>
		</>
	);
};

export default LoginInput;
